import '../styles/app.scss';
import './_images';

import { gfReadOnlyFields } from './components/gfReadOnlyFields';
import './components/jquery.validate';
import { checkout } from './components/checkout';
import { commentForm } from './components/comment-form';
import {accordeonMenu} from "./components/accordeon-menu";
import {niftichat} from "./components/niftichat";
import {scroll} from "./components/scroll";

document.addEventListener(
	'DOMContentLoaded',
	() => {
		gfReadOnlyFields();
		checkout();
		commentForm();
		accordeonMenu();
		niftichat();
		scroll();
	},
	false
);
